const endpoints = {
  createIdentity: (): string => `identity`,
  updateIdentity: (id: string): string => `identity/${id}`,
  deleteIdentity: (id: string): string => `identity/${id}`,
};

export default endpoints;
